import clsx from "clsx";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { AssetManager } from "utils/AssetManager";

export const ReplyDisplay = (props: {
    body: string;
    author?: string;
    isWinner?: boolean;
    isChosen?: boolean;
    characterId?: number;
    votes?: number;
    isPerfect?: boolean;
    isRejected?: boolean;
    url?: string;
    urlNewWindow?: boolean;
    hasSticker?: boolean;
    isViolation?: boolean;
    watchWords?: Array<string>;
    showVotingEnabled?: boolean;
}) => {
    const {
        body,
        isWinner,
        author,
        votes,
        characterId,
        isChosen,
        isPerfect,
        isRejected,
        url,
        urlNewWindow,
        hasSticker,
        isViolation,
        showVotingEnabled,
        watchWords = [],
    } = props;

    const { characters } = AssetManager;

    const c = characterId != null ? characters[characterId] : null;

    return (
        <div className="reply">
            <div className="d-flex fw-bold justify-content-between align-items-end gap-lg-3 mx-n1">
                <div className="d-flex align-items-end gap-2">
                    {c && (
                        <div style={{ width: 96 }}>
                            <img src={c} alt="" className="img-fluid" />
                        </div>
                    )}

                    {author && (
                        <div className="pb-2">
                            {url ? (
                                <Link target={urlNewWindow ? "_blank" : undefined} className="link-white pb-0" to={url}>
                                    {author}
                                </Link>
                            ) : (
                                author
                            )}
                        </div>
                    )}
                </div>

                {votes != null && votes > 0 && (
                    <div className="pb-2 text-nowrap d-flex gap-2">
                        <div>
                            {votes} {votes === 1 ? "vote" : "votes"}
                        </div>
                    </div>
                )}
            </div>

            <blockquote
                className={clsx(
                    "reply__quote text-break animate",
                    !body && "reply-empty",
                    isPerfect
                        ? "reply__quote--perfect"
                        : isWinner
                        ? "reply__quote--winner"
                        : isChosen && "reply__quote--chosen",
                    hasSticker && "reply__quote--sticker",
                    showVotingEnabled && (isRejected ? "reply__quote--rejected" : "reply__quote--accepted"),
                )}
            >
                <Highlighter
                    textToHighlight={body}
                    autoEscape={true}
                    searchWords={showVotingEnabled ? watchWords : []}
                />

                {isPerfect && (
                    <div className="position-absolute top-0 start-0 translate-middle">
                        <span className="badge bg-success">100%</span>
                    </div>
                )}

                {isViolation && (
                    <div className="position-absolute translate-middle top-50 start-0" title="Watch list reply">
                        <span className="badge bg-white text-white border border-3 border-danger px-1 fs-6">🚨</span>
                    </div>
                )}
            </blockquote>
        </div>
    );
};
